import { createEvent, createStore } from "effector";

import type { SessionState } from "./types";

export const newSession = createEvent<{ accessToken: string }>();
export const closeSession = createEvent();

export const $session = createStore<SessionState>({});

$session
  .on(newSession, (state, payload) => ({
    ...state,
    accessToken: payload.accessToken,
  }))
  .on(closeSession, (state) => ({
    ...state,
    accessToken: undefined,
  }));
